<template>
    <div v-if="lang == 'de'">
        <p>Sie haben ein neues Forschungsprojekt, welches …</p>
        <ul class="">
            <li class="">das Thema Flucht und/oder Geflüchtete behandelt</li>
            <li class="">auf eigenen empirischen Untersuchungen basiert</li>
            <li class="">unter Beteiligung mindestens einer Forschungsinstitution in Deutschland durchgeführt wird</li>
            <li class="">ein eigenes Budget aufweist (intern, Drittmittel, Stellen oder Stipendien)</li>
            <li class="">nicht vor 2011 abgeschlossen war</li>
            <li class="">eine Mindestlaufzeit von drei Monaten umfasst,</li>
        </ul>
        <p>
            dann <a href="/user/register/de?for=project-input"><strong>registrieren</strong></a> sie sich auf unsere Webseite.
            Anschließend können sie neue Projekte anlegen oder bearbeiten.
        </p>

        <p>
            Falls sie Fragen haben, dann können sie uns gerne unter
            <a href="mailto:data@ffvt.net"><strong>data@ffvt.net</strong></a>
            kontaktieren.
        </p>

        <!-- <p>Die entsprechenden Formulare mit einer Datenschutzerklärung finden Sie hier:</p>
        <p>
            <a href="/docs/FFVT-Formular-2020-de.docx">Formular</a> (deutch)
            | <a href="/docs/FFVT-Formular-2020-en.docx">Formular</a> (englisch)
        </p> -->

        <p>Der Ort Ihrer Forschungseinrichtung erscheint dann auf der interaktiven Forschungslandkarte.</p>
    </div>

    <div v-if="lang == 'en'">
        <p>You have a new research project that ...</p>
        <ul>
            <li>addresses the issue of forced migration and/or refugees</li>
            <li>based on own empirical research</li>
            <li>is carried out with the participation of at least one research institution in Germany</li>
            <li>has its own budget (internal, third-party funds, posts or scholarships)</li>
            <li>was not completed before 2011</li>
            <li>a minimum term of three months,</li>
        </ul>

        <p>
            then please
            <a href="/user/register/en?for=project-input"><strong>register</strong></a>
            on our website. Then you can create or edit new projects.
        </p>

        <p>
            If you have any questions, please feel free to contact us at
            <a href="mailto:data@ffvt.net"><strong>data@ffvt.net</strong></a>.
        </p>

        <!-- <p>You can find the corresponding forms with a data protection declaration here:</p>
        <p>
            <a href="/docs/FFVT-Formular-2020-de.docx">Form</a> (German)
            | <a href="/docs/FFVT-Formular-2020-en.docx">Form</a> (English)
        </p> -->

        <p>The location of your research institution will then appear on the interactive research landscape map.</p>
    </div>

</template>

<script>
export default {
    props: {
        lang: {
            type: String,
            default: () => 'de'
        }
    }
}
</script>